import { switchMailOn, whyNotEmailed } from '../lib/mail'
import { TASK_VERB } from '../lib/status'
import { mailOutcome, type MailSummary } from '../views/Campaigns'

// What a campaign page says when its invitations were recorded and not
// emailed: mail muted on the installation, or switched off for the workspace.
//
// The same account, and the same what to do, as the invitation screen gives
// for one vendor (components/InviteSent.tsx): nothing was emailed, the
// questionnaires are there, switch mail on, then resend each one. A campaign
// that said "invitations queued" and "Sent" over a list of red "Failed" rows
// told the person reading it the opposite of what happened (release-3
// rehearsal, 26 Sep 2026). Nothing is said when every invitation went.
export function CampaignNotEmailed({ mail }: { mail: MailSummary }) {
  const outcome = mailOutcome(mail)
  if (outcome === 'none') return null
  const all = outcome === 'all'
  return (
    <div className="note warn" role="status">
      <strong>
        {all
          ? 'Recorded, not emailed'
          : mail.notEmailed + ' of ' + mail.issued + ' invitations recorded, not emailed'}
      </strong>
      <p style={{ margin: '4px 0 0' }}>{whyNotEmailed(mail.mail)}</p>
      <p style={{ margin: '4px 0 0' }}>
        {all
          ? 'The questionnaires are issued and recorded, and no vendor was emailed: they have neither the invitation nor, by email, the one time code they need to sign in.'
          : 'Those questionnaires are issued and recorded, and those vendors were not emailed: they have neither the invitation nor, by email, the one time code they need to sign in.'}
      </p>
      <h3 style={{ marginBottom: 4 }}>What to do</h3>
      <ol style={{ margin: 0 }}>
        <li>{switchMailOn({ mail: mail.mail })}</li>
        <li>
          Then open each vendor marked Recorded, not emailed below and press {TASK_VERB.chase} on its next step. The
          invitation goes with the same link and due date.
        </li>
      </ol>
    </div>
  )
}
